(function () {
  const CONTEXT_ID = 'gtm-datalayer-context';
  const INTERNAL_COOKIE_NAME = 'vecicky_internal_traffic';
  const INTERNAL_COOKIE_MAX_AGE = 365 * 24 * 60 * 60;

  function readContext() {
    const element = document.getElementById(CONTEXT_ID);
    if (!element) {
      return null;
    }

    try {
      return JSON.parse(element.textContent || '');
    } catch (error) {
      return null;
    }
  }

  function readCookieValue(cookieName) {
    const prefix = cookieName + '=';
    const parts = document.cookie.split(';');

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        return part.substring(prefix.length);
      }
    }

    return null;
  }

  function writeInternalCookie() {
    let cookie =
      INTERNAL_COOKIE_NAME +
      '=1; path=/' +
      '; max-age=' +
      INTERNAL_COOKIE_MAX_AGE +
      '; SameSite=Lax';

    if (window.location.protocol === 'https:') {
      cookie += '; Secure';
    }

    document.cookie = cookie;
  }

  function clearInternalCookie() {
    let cookie = INTERNAL_COOKIE_NAME + '=; path=/; max-age=0; SameSite=Lax';

    if (window.location.protocol === 'https:') {
      cookie += '; Secure';
    }

    document.cookie = cookie;
  }

  function hasInternalCookie() {
    return readCookieValue(INTERNAL_COOKIE_NAME) === '1';
  }

  /**
   * Logged-in customer tag `internal` sets a persistent cookie.
   * Anonymous sessions keep using the cookie until a non-internal customer logs in.
   */
  function resolveInternalTraffic(context) {
    const visitor = context && context.visitor;

    if (visitor && visitor.isInternalCustomer === true) {
      writeInternalCookie();
      return { isInternal: true, internalReason: 'customer_tag' };
    }

    if (visitor && visitor.isInternalCustomer === false) {
      clearInternalCookie();
      return { isInternal: false, internalReason: null };
    }

    if (hasInternalCookie()) {
      return { isInternal: true, internalReason: 'cookie' };
    }

    return { isInternal: false, internalReason: null };
  }

  function enrichVisitor(visitor, context) {
    const resolved = resolveInternalTraffic(context || readContext());
    return Object.assign({}, visitor || {}, {
      isInternal: resolved.isInternal,
      internalReason: resolved.internalReason,
    });
  }

  function isActive(context) {
    return resolveInternalTraffic(context || readContext()).isInternal;
  }

  resolveInternalTraffic(readContext());

  window.VecickyGtmInternalTraffic = {
    INTERNAL_COOKIE_NAME: INTERNAL_COOKIE_NAME,
    enrichVisitor: enrichVisitor,
    isActive: isActive,
    resolveInternalTraffic: resolveInternalTraffic,
    hasInternalCookie: hasInternalCookie,
    writeInternalCookie: writeInternalCookie,
    clearInternalCookie: clearInternalCookie,
  };
})();
